import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as XLSX from 'xlsx';
import { DigisubservicesService } from '../services/digisubservices.service';

@Component({
  selector: 'app-monthwise-report',
  templateUrl: './monthwise-report.component.html',
  styleUrls: ['./monthwise-report.component.scss']
})
export class MonthwiseReportComponent implements OnInit {

  monthRows: any[] = [];
  // grandTotal: any = { jama: 0, yeneBaki: 0 };
  startDate: any;
  endDate: any;
  today: Date = new Date();

  constructor(
    private service: DigisubservicesService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    debugger
    this.startDate = this.data?.startDate;
    this.endDate = this.data?.endDate;
    this.loadReport();
  }

  // ==================== GET API DATA ====================
  loadReport() {
    debugger
    const payload = {
      start_date: this.startDate,
      end_date: this.endDate,
      rep_name: this.data?.rep_name,
      office_rep_name: this.data?.office_rep_name
    };

    this.service.getBusinessReport3(payload).subscribe((res: any) => {
      if (!res || res.status !== 'success') return;

      this.monthRows = res.data || [];

      this.calculateGrandTotal();
    });
  }
  grandTotal = {
  chaluVarsh: 0,
  jama: 0,
  crdtnote_total: 0,
  yeneBaki: 0
};

  // ==================== CALCULATE TOTAL ====================
  calculateGrandTotal() {
  this.grandTotal = {
    chaluVarsh: 0,
    jama: 0,
    crdtnote_total: 0,
    yeneBaki: 0
  };

  this.monthRows.forEach(row => {
    this.grandTotal.chaluVarsh += Number(row.chaluVarsh) || 0;
    this.grandTotal.jama += Number(row.jama) || 0;
    this.grandTotal.crdtnote_total += Number(row.crdtnote_total) || 0;
    this.grandTotal.yeneBaki += Number(row.yeneBaki) || 0;
  });
}

  // ==================== PRINT ====================
  printPageA4(): void {
  const printContent = document.getElementById('print-section'); // ✅ FIXED ID
  if (!printContent) return;

  const WindowPrt = window.open('', '', 'width=900,height=1200');

  WindowPrt!.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <title>Business Report</title>

        <style>
          * {
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }

          @page {
            size: A4 portrait;
            margin: 10mm;
          }

          body {
            margin: 0;
            font-family: Arial, sans-serif;
            font-size: 10px; /* better fit */
            color: #000;
          }

          table {
            width: 100%;
            border-collapse: collapse;
            table-layout: fixed;
          }

          th, td {
            border: 1px solid #000;
            padding: 4px;
            word-wrap: break-word;
          }

          thead {
            display: table-header-group;
          }

          tfoot {
            display: table-footer-group;
          }

          tr {
            page-break-inside: avoid;
          }

          .noPrint {
            display: none !important;
          }

          button {
            display: none !important;
          }
        </style>
      </head>

      <body>
        ${printContent.innerHTML}
      </body>
    </html>
  `);

  WindowPrt!.document.close();
  WindowPrt!.focus();

  setTimeout(() => {
    WindowPrt!.print();
    WindowPrt!.close();
  }, 500);
}

  // ==================== EXPORT TO EXCEL ====================
   exportExcel(fileName: string): void {
        const element = document.getElementById('print-section');
        if (!element) return;
    
        try {
          const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
          const wb: XLSX.WorkBook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
          XLSX.writeFile(wb, fileName + '.xlsx');
        } catch (error) {
          console.error('Export error:', error);
        }
      }
}